import Vue from "vue";
import Router from "vue-router";
import UserDashboard from "./pages/UserDashboard";
import UserComments from "./pages/UserComments";
import UserProfile from "./pages/UserProfile";
import UserAlias from "./pages/UserAlias";
import UserSettings from "./pages/UserSettings";
import VisitedProfile from "./pages/VisitedProfile";
import { getCookie } from "./helpers/functions";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "dashboard",
      component: UserDashboard,
      beforeEnter: redirectIfNotAuth,
    },
    {
      path: "/settings",
      name: "settings",
      component: UserSettings,
      beforeEnter: redirectIfNotAuth,
    },
    {
      path: "/profile",
      name: "profile",
      component: UserProfile,
      beforeEnter: redirectIfNotAuth,
    },
    {
      path: "/alias",
      name: "alias",
      component: UserAlias,
      beforeEnter: redirectIfNotAuth,
    },
    {
      path: "/comments",
      name: "comments",
      component: UserComments,
      beforeEnter: redirectIfNotAuth,
    },
    {
      path: "/user",
      name: "user",
      component: VisitedProfile,
    },
  ],
});

function redirectIfNotAuth(to, from, next) {
  const cookie = getCookie("ifragasatt_cookie");
  (cookie != null) ? next() : window.location.href = `${process.env.VUE_APP_SIGNUP_ROUTE}/?origin=mitt`;
}
